module.exports = __webpack_public_path__ + "static/media/road_travel.c39e454e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road_travel.png
// module id = 303
// module chunks = 0